var PendenciesModule = /** @class */ (function () {
    function PendenciesModule() {
    }
    return PendenciesModule;
}());
export { PendenciesModule };
